<template>
    <teleport to="body">
        <transition name="modal">
            <div v-if="open" class="overlay" @mousedown.self="$emit('close')">
                <div class="modal card neon glow" role="dialog" aria-modal="true">
                    <!-- 顶部一条流光，强调"系统级弹窗" -->
                    <div class="modal-beam"></div>

                    <div class="head">
                        <div class="title">{{ title }}</div>
                        <button class="x" @click="$emit('close')" title="关闭">✕</button>
                    </div>

                    <div v-if="message" class="msg mono muted">{{ message }}</div>

                    <div class="body">
                        <slot />
                    </div>

                    <div class="foot">
                        <button v-if="showCancel" class="btn" @click="$emit('cancel')">取消</button>
                        <button class="btn btn-primary" @click="$emit('ok')">{{ okText }}</button>
                    </div>
                </div>
            </div>
        </transition>
    </teleport>
</template>

<script>
export default {
    name: "CyberModal",
    props: {
        open: { type: Boolean, default: false },
        title: { type: String, default: "Confirm" },
        message: { type: String, default: "" },
        okText: { type: String, default: "确认" },
        showCancel: { type: Boolean, default: true },
    },
    emits: ["close", "cancel", "ok"],
    watch: {
        // 打开时监听 ESC 关闭，关闭时移除，避免监听泄漏
        open(v) {
            if (v) window.addEventListener("keydown", this.onKey);
            else window.removeEventListener("keydown", this.onKey);
        },
    },
    beforeUnmount() {
        window.removeEventListener("keydown", this.onKey);
    },
    methods: {
        onKey(e) {
            if (e.key === "Escape") this.$emit("close");
        },
    },
};
</script>

<style scoped>
.overlay {
    position: fixed;
    inset: 0;
    background: rgba(3, 5, 12, .6);
    backdrop-filter: blur(10px);
    display: grid;
    place-items: center;
    z-index: 9999;
    padding: 16px;
}

.modal {
    position: relative;
    width: min(560px, 100%);
    padding: 18px;
    overflow: hidden;
}

.modal-beam {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: var(--grad-main);
    opacity: .9;
}

.head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
}

.title {
    font-weight: 800;
    font-size: 17px;
    letter-spacing: .02em;
}

.msg {
    margin-top: 8px;
    font-size: 13px;
    word-break: break-all;
}

.body {
    margin-top: 14px;
}

.foot {
    margin-top: 18px;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
}

.x {
    border: 1px solid var(--stroke);
    background: rgba(255, 255, 255, .05);
    color: var(--muted);
    border-radius: 10px;
    width: 32px;
    height: 32px;
    cursor: pointer;
    transition: all var(--t);
}

.x:hover {
    border-color: rgba(255, 77, 141, .55);
    color: #fff;
}

/* 入场：遮罩淡入 + 弹窗轻微放大上浮 */
.modal-enter-active,
.modal-leave-active {
    transition: opacity var(--t);
}

.modal-enter-active .modal,
.modal-leave-active .modal {
    transition: transform var(--t) cubic-bezier(.22, 1, .36, 1), opacity var(--t);
}

.modal-enter-from,
.modal-leave-to {
    opacity: 0;
}

.modal-enter-from .modal,
.modal-leave-to .modal {
    transform: translateY(16px) scale(.96);
    opacity: 0;
}
</style>
